__turbopack_context__.v({
  "bodyText": "PrizeRedemptionModal-module__ma3OeG__bodyText",
  "buttonContainer": "PrizeRedemptionModal-module__ma3OeG__buttonContainer",
  "closeButton": "PrizeRedemptionModal-module__ma3OeG__closeButton",
  "container": "PrizeRedemptionModal-module__ma3OeG__container",
  "heroSection": "PrizeRedemptionModal-module__ma3OeG__heroSection",
  "inputTextBox": "PrizeRedemptionModal-module__ma3OeG__inputTextBox",
  "listItem": "PrizeRedemptionModal-module__ma3OeG__listItem",
  "mainContainer": "PrizeRedemptionModal-module__ma3OeG__mainContainer",
  "message": "PrizeRedemptionModal-module__ma3OeG__message",
  "overviewBody": "PrizeRedemptionModal-module__ma3OeG__overviewBody",
  "prizeFulfillmentText": "PrizeRedemptionModal-module__ma3OeG__prizeFulfillmentText",
  "selectedPrizeSubheading": "PrizeRedemptionModal-module__ma3OeG__selectedPrizeSubheading",
  "selectedPrizeTitle": "PrizeRedemptionModal-module__ma3OeG__selectedPrizeTitle",
  "subText": "PrizeRedemptionModal-module__ma3OeG__subText",
  "thumbnail": "PrizeRedemptionModal-module__ma3OeG__thumbnail",
  "whatsIncluded": "PrizeRedemptionModal-module__ma3OeG__whatsIncluded",
});
